let redoStack = [];

const set = (stack) => {
  redoStack = stack;
  return stack.length;
};

const get = () => redoStack;

export default {
  set,
  get,
};
